import ATableAccess from "./aTableAccess";

class OrderItemAccess extends ATableAccess {}

export default OrderItemAccess;
